export enum EInteractionEvents {
    LeadSubmit = 'lead_estfunnel_form_submit',
    Confirmation = 'estimation_funnel_confirmation',
}

export enum EMonthlyPriceUpdateInteractionEvents {
    LeadSubmit = 'monthly_price_update_submit',
    Confirmation = 'monthly_price_update_confirm',
    MFASuccess = 'multifactor_authentification',
    MFAError = 'multifactor_authentification_error',
}

export enum EAvCategory {
    Estimate = 'estimate',
    EstimationFunnel = 'estimation_funnel',
    Account = 'account',
    Error = 'error',
}

export enum EAvInitiative {
    EstimationFunnel = 'wl_ef',
    MonthlyPriceUpdate = 'wl_mpu',
}

export enum EAvDistributionTypeGlobal {
    Rent = '1',
    Buy = '2',
}

export enum EAvEstateTypeGlobal {
    Apartment = 'av_2',
    House = 'av_4',
}
